<template>
    <div id="filePath_main">
        <button class="bt bt-normal bg-white fc-gray-dark bt-hover-dark" v-for="path in bucketPathArray" @click="select(path)">
            {{ path || 'Main' }}
            /
        </button>
    </div>
</template>

<script>
    export default {
        name: "filePath",
        data(){
            return{

            }
        },
        computed: {
            bucketPath(){
                return this.$store.getters['Fs/get_bucketPath']
            },
            bucketPathArray(){
                let bucketPath = this.$store.getters['Fs/get_bucketPath'];
                let arr = bucketPath.split('/');
                return arr;

            }
        },
        methods: {
            select(p){
                let i = this.bucketPathArray.indexOf(p);
                if(i === this.bucketPathArray.length - 1){
                    return null
                }
                let path = this.bucketPathArray.slice(0, i + 1).join('/');
                this.$emit('selectHistory', path)
            }
        }
    }
</script>

<style scoped>
    #filePath_main{
        padding-left: 10px;
    }
</style>
